module.exports = __webpack_public_path__ + "img/audio_button.423d196b.png";